import { App } from 'vue';
import DialogV2 from './src/index.vue';

DialogV2.install = (app: App): void => {
    app.component(DialogV2.name, DialogV2);
};

export default DialogV2;
export { default as useDialog } from './src/useDialog';

declare module 'vue' {
    export interface GlobalComponents {
        DialogV2: typeof DialogV2;
    }
}
